<template>
	<div class="leftbar">
		<div class="title">
			功能导航
		</div>
		<div class="item" @click="handleFreeLive" :class="{'active':rootName=='live'}">
			<img src="../assets/img/freeliveactive.png" v-if="rootName == 'live'">
			<img src="../assets/img/freeLive.png" v-else>
			<span class="name">免费直播</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'live'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleHomeWork()" :class="{ 'active': rootName == 'homeworklist' }">
			<img src="../assets/img/homeworkactive.png" v-if="rootName == 'homeworklist'">
			<img src="../assets/img/homework.png" v-else>
			<span class="name">章节练习</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'homeworklist'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleTraining()" :class="{ 'active': rootName == 'training' }">
			<img src="../assets/img/allactive.png" v-if="rootName == 'training'">
			<img src="../assets/img/all.png" v-else>
			<span class="name">阶段测试</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'training'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleHighfrequency()" :class="{ 'active': rootName == 'highfrequency' }">
			<img src="../assets/img/highfrequtactive.png" v-if="rootName == 'highfrequency'">
			<img src="../assets/img/highfrequt.png" v-else>
			<span class="name">高频考点</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'highfrequency'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<!-- <div class="item" @click="handleDouble()" :class="{ 'active': rootName == 'double' }">
			<img src="../assets/img/twotwoactive.png" v-if="rootName == 'double'">
			<img src="../assets/img/twotwo.png" v-else>
			<span class="name">二二密训</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'double'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line"> -->

		<div class="item" @click="handleHistory()" :class="{ 'active': rootName == 'history' }">
			<img src="../assets/img/historyactive.png" v-if="rootName == 'history'">
			<img src="../assets/img/history.png" v-else>
			<span class="name">历年真题</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'history'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleTest()" :class="{ 'active': rootName == 'examination' }">
			<img src="../assets/img/moniactive.png" v-if="rootName == 'examination'">
			<img src="../assets/img/moni.png" v-else>
			<span class="name">模拟考试</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'examination'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleBefore()" :class="{ 'active': rootName == 'beforeexamination' }">
			<img src="../assets/img/beforeactive.png" v-if="rootName == 'beforeexamination'">
			<img src="../assets/img/beforeEaxm.png" v-else>
			<span class="name">考前押题</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'beforeexamination'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleError" :class="{ 'active': rootName == 'errorcollect' }">
			<img src="../assets/img/erroractive.png" v-if="rootName == 'errorcollect'">
			<img src="../assets/img/error.png" v-else>
			<span class="name">错题收藏</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'errorcollect'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item"
			:class="{ 'active': rootName == 'teacheranswers' || rootName == 'submitquestion' || rootName == 'myteacheranswers' }"
			@click="handleTeacherAnswer">
			<img src="../assets/img/teacheractive.png"
				v-if="rootName == 'teacheranswers' || rootName == 'submitquestion' || rootName == 'myteacheranswers'">
			<img src="../assets/img/teacheranswer.png" v-else>
			<span class="name">老师答疑</span>
			<img src="../assets/img/torightactive.png"
				v-if="rootName == 'teacheranswers' || rootName == 'submitquestion' || rootName == 'myteacheranswers'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleNewList" :class="{ 'active': rootName == 'newslist' || rootName == 'newsdetail' }">
			<img src="../assets/img/studyactive.png" v-if="rootName == 'newslist' || rootName == 'newsdetail'">
			<img src="../assets/img/study.png" v-else>
			<span class="name">学习指导</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'newslist' || rootName == 'newsdetail'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="item" @click="handleShow()">
			<img src="../assets/img/answershow.png">
			<span class="name">答题演示</span>
			<img src="../assets/img/torightactive.png" v-if="rootName == 'live'">
			<img src="../assets/img/toright.png" v-else>
		</div>
		<div class="line">

		</div>
		<div class="text-center" style="margin-top: 15px;">
			<img src="../assets/img/download.png" width="110">
			<div class="font14">
				下载APP
			</div>
		</div>
		<div class="text-center">
			<img src="../assets/img/kaozheng.jpeg" width="110">
			<div class="font14">
				在职考证
			</div>
		</div>
    <div class="text-center">
    	<img src="../assets/img/kaoyan.jpeg" width="110">
    	<div class="font14">
    		在职考研
    	</div>
    </div>
		<div class="text-center" style="margin-bottom: 30px;">
			<img src="../assets/img/onlineserve.jpeg" width="110">
			<div class="font14">
				联系客服
			</div>
		</div>
	</div>
	</div>

</template>

<script>
export default {
	name: 'Footer',
	components: {

	},
	data () {
		return {
			showLogin: false,
			rootName: ''
		}
	},
	methods: {



		handleNewList () {
			this.$router.push('newslist')
		},
		handleFreeLive () {  //免费直播
			this.$router.push('live')
		},
		handleHomeWork () {  //课后练习
			this.$router.push('homeworklist')
		},
		handleTraining () {  //综合专训
			this.$router.push('training')
		},
		handleHighfrequency () { //高频考点
			this.$router.push('highfrequency')
		},
		handleDouble () { //二二密训
			this.$router.push('double')
		},
		handleHistory () {  //历年真题
			this.$router.push('history')
		},
		handleTest () {  //模拟考试
			this.$router.push('examination')
		},
		handleBefore () {  //靠前押题
			this.$router.push('beforeexamination')
		},
		handleError () {  //错题收藏
			this.$router.push('errorcollect')
		},
		handleTeacherAnswer () {  // 老师答疑
			this.$router.push('teacheranswers')
		},
		handleShow () { //答题演示
			window.open('http://kzp.mof.gov.cn/moni.jsp')
		}
	},
	created () {
		this.rootName = this.$route.name;
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/left.vue